module.exports = "<div class=\"progress\">\r\n    <div class=\"progress-bar progress-bar-striped active\"\r\n         role=\"progressbar\"\r\n         [ngStyle]=\"{width: progressBarWidth}\">\r\n    </div>\r\n</div>\r\n<!--<div *ngIf=\"!progressBarIsValid\">\r\n    remainingTime is greater than totalTime\r\n</div>-->"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/progressBar/progress-bar.component.html
// module id = ../../../../../app/shared/components/progressBar/progress-bar.component.html
// module chunks = main